<template>
  <dialog
    class="MenuModal"
    data-theme="light"
    open
  >
    <div
      class="MenuModal__backdrop"
      @click="$emit('close')"
    />
    <section
      class="MenuModal__window"
    >
      <slot />
    </section>
  </dialog>
</template>

<script setup lang="ts">
defineEmits<{
  close: [],
}>();
</script>

<style lang="scss" scoped>
.MenuModal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  isolation: isolate;

  display: grid;
  place-items: end center;
  width: 100%;
  height: 100%;
  padding: 24px 16px max(24px, var(--safeAreaInsetBottom));

  transition: none 350ms;
}

.MenuModal__backdrop {
  position: absolute;
  inset: 0;
  z-index: -1;

  background-color: var(--themeColorBackdrop);
  backdrop-filter: blur(6px);

  transition: opacity 350ms var(--easeOutBack);

  .v-leave-active & {
    transition: 350ms;
    transition-timing-function: initial;
  }

  .v-enter-from &,
  .v-leave-to & {
    opacity: 0;
  }
}

.MenuModal__window {
  display: grid;
  width: 100%;

  border-radius: 16px;
  background-color: var(--themeColorNeutral0);

  .v-enter-active & {
    transition: 335ms cubic-bezier(0.25, 1, 0.30, 1);
    transition-property: opacity, transform;
  }

  .v-leave-active & {
    transition: 280ms var(--easeInQuad);
    transition-property: opacity, transform;
  }

  .v-enter-from &,
  .v-leave-to & {
    transform: translateY(100%);
    opacity: 0;
  }
}
</style>
